// Função para salvar informações de autenticação no cache
export const saveAuthData = (token, user = null) => {
    if (token) {
        localStorage.setItem("auth_token", token);
    }
    if (user) {
        localStorage.setItem("user", JSON.stringify(user));
    }

    localStorage.setItem("auth_timestamp", Date.now().toString());
};

// Função para obter informações de autenticação do cache
export const getAuthData = () => {
    const token = localStorage.getItem("auth_token");
    const user = localStorage.getItem("user");
    const timestamp = localStorage.getItem("auth_timestamp");

    return {
        token,
        user: user ? JSON.parse(user) : null,
        timestamp: timestamp ? parseInt(timestamp) : null
    };
};

// Função para verificar se o usuário está autenticado
export const isAuthenticatedByCache = () => {
    const authData = getAuthData();
    // Verifica se existe token no cache
    // Você pode adicionar validação de expiração aqui se necessário -> timestamp
    return Boolean(authData.token);
};

// Função para obter o usuário do cache
export const getUser = () => {
    const authData = getAuthData();
    return authData.user;
};

// Função para limpar dados de autenticação
export const clearAuthData = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user");
    localStorage.removeItem("auth_timestamp");
};

// Função para fazer logout
export const logoutLocalStorage = () => {
    clearAuthData();
};